// extracted by mini-css-extract-plugin
export default {"focusable":"styles_focusable__BNkeZ","link":"styles_link__Awmqf","spatialActive":"styles_spatialActive__fzH3+","active":"styles_active__4TzL+","newBadge":"styles_newBadge__GhdVC"};